export enum PrivacyLevel {
    Unknown = 'Unknown',
    SiteAdmin = 'SiteAdmin',
    FinanceEmployee = 'FinanceEmployee',
    GroupLead = 'GroupLead',
    Member = 'Member',
}
